import {
    Box,
    Card,
    Tabs,
    Tab,
    Typography,
    TextField,
    Button,
    Grid,
    IconButton,
    Avatar,
    useTheme,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useState } from "react";
import { Link } from "react-router-dom";
import BasicInfoForm from "../components/resume/BasicInfoForm";
import ContactForm from "../components/resume/ContactForm";
import LanguageForm from "../components/resume/LanguageForm";
import SkillsForm from "../components/resume/SkillsForm";
import WorkExperienceForm from "../components/resume/WorkExperienceForm";
import EducationForm from "../components/resume/EducationForm";
import TrainingCertForm from "../components/resume/TrainingForm";
import HobbiesForm from "../components/resume/HobbiesForm";
import AchievementsForm from "../components/resume/AchievementsForm";
import { ResumeProvider } from "../ResumeContext";

export default function ResumeBuilderForm() {
    const theme = useTheme();
    const [tab, setTab] = useState(0);
    const [image, setImage] = useState(null);

    const handleTabChange = (e, newVal) => {
        setTab(newVal);
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) setImage(URL.createObjectURL(file));
    };
    const goNextTab = () => {
        setTab((prev) => prev + 1);
    };

    const goPrevTab = () => {
        setTab((prev) => prev - 1);
    };


    return (
        <Box sx={{ backgroundColor: theme.palette.background.default, p: 3 }}>
            <Box
                sx={{
                    p: 3,

                    borderRadius: 2,
                    background: theme.palette.background.paper,
                }}
            >
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="p" fontWeight={400} color={theme.palette.text.primary} >
                        Build your Resume
                    </Typography>

                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontWeight: 400,
                            fontSize: 13,
                            cursor: "pointer",
                            textDecoration: "underline",
                        }}
                    >
                        <Link to={"/templates"}>
                            See Templates
                        </Link>
                    </Typography>
                </Box>

                {/* Tabs */}
                <Tabs
                    value={tab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons
                    sx={{
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        mb: 3,
                    }}
                >
                    {[
                        "Basic Info",
                        "Contact",
                        "Language",
                        "Skills",
                        "Work Experience",
                        "Education",
                        "Training and Certificates",
                        "Achievements",
                        "Hobbies",
                    ].map((label, index) => (
                        <Tab
                            key={index}
                            label={label}
                            sx={{ textTransform: "none", fontWeight: 500 }}
                        />
                    ))}
                </Tabs>


                <ResumeProvider>
                    <div>
                        {tab === 0 && <BasicInfoForm onNext={goNextTab} />}
                        {tab === 1 && <ContactForm onNext={goNextTab} />}
                        {tab === 2 && <LanguageForm onNext={goNextTab} />}
                        {tab === 3 && <SkillsForm onNext={goNextTab} />}
                        {tab === 4 && <WorkExperienceForm onNext={goNextTab} />}
                        {tab === 5 && <EducationForm onNext={goNextTab} />}
                        {tab === 6 && <TrainingCertForm onNext={goNextTab} />}
                        {tab === 7 && <AchievementsForm onNext={goNextTab} />}
                        {tab === 8 && <HobbiesForm onNext={goNextTab} />}
                    </div>
                </ResumeProvider>

            </Box>
        </Box>
    );
}
